


export class KE30 {
  "coluna1";
  "coluna2";
  "actualDataBacklog";
  "actualDataCos";
  "actualDataCosExt";
  "actualDataCosInt";
  "actualDataNetSales";
  "actualDataObCos";
  "actualDataObSales";
  "actualDataOpBacklog";
  "actualDataTotalCos";
  "actualDataUgm";
  "billToParty";
  "billToParty2";
  "businessArea";
  "businessArea2";
  "buyingBusinessUnit";
  "buyBusUnit";
  "commodity";
  "commodity2";
  "country";
  "countryFinalDest";
  "countryInvoiced";
  "countryInvoiced2";
  "country2";
  "currency";
  "customer";
  "customer2";
  "distributionChannel";
  "distrChannel";
  "division";
  "division2";
  "ericssonContractNumber";
  "globalCustomer";
  "globalCustomer2";
  "industry";
  "industry2";
  "pCode";
  "pCode2";
  "periodYear";
  "periodYear2";
  "planActIndicator";
  "planActIndicator2";
  "plant";
  "plant2";
  "product";
  "product2";
  "profitCenter";
  "profitCenter2";
  "recordType";
  "recordType2";
  "region";
  "regionState";
  "salesOrder";
  "salesOrderHistory";
  "salesOrdHist";
  "salesOrderItem";
  "salesOrdItem";
  "salesOrder2";
  "salesOrganization";
  "salesOrg";
  "shipToParty";
  "shipToParty2";
  "soGroup";
  "soGroup2";
  "soOffice";
  "soOffice2";
  "soldToParty";
  "soldToParty2";
  "solutionCode";
  "solutionCode2";
  "wbsElement";
  "wbsElement2";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `KE30`.
   */
  static getModelName() {
    return "KE30";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of KE30 for dynamic purposes.
  **/
  static factory(data) {
    return new KE30(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'KE30',
      plural: 'KE30s',
      path: 'KE30s',
      properties: {
        "coluna1": {
          name: 'coluna1',
          type: 'string'
        },
        "coluna2": {
          name: 'coluna2',
          type: 'string'
        },
        "actualDataBacklog": {
          name: 'actualDataBacklog',
          type: 'string'
        },
        "actualDataCos": {
          name: 'actualDataCos',
          type: 'string'
        },
        "actualDataCosExt": {
          name: 'actualDataCosExt',
          type: 'string'
        },
        "actualDataCosInt": {
          name: 'actualDataCosInt',
          type: 'string'
        },
        "actualDataNetSales": {
          name: 'actualDataNetSales',
          type: 'string'
        },
        "actualDataObCos": {
          name: 'actualDataObCos',
          type: 'string'
        },
        "actualDataObSales": {
          name: 'actualDataObSales',
          type: 'string'
        },
        "actualDataOpBacklog": {
          name: 'actualDataOpBacklog',
          type: 'string'
        },
        "actualDataTotalCos": {
          name: 'actualDataTotalCos',
          type: 'string'
        },
        "actualDataUgm": {
          name: 'actualDataUgm',
          type: 'string'
        },
        "billToParty": {
          name: 'billToParty',
          type: 'string'
        },
        "billToParty2": {
          name: 'billToParty2',
          type: 'string'
        },
        "businessArea": {
          name: 'businessArea',
          type: 'string'
        },
        "businessArea2": {
          name: 'businessArea2',
          type: 'string'
        },
        "buyingBusinessUnit": {
          name: 'buyingBusinessUnit',
          type: 'string'
        },
        "buyBusUnit": {
          name: 'buyBusUnit',
          type: 'string'
        },
        "commodity": {
          name: 'commodity',
          type: 'string'
        },
        "commodity2": {
          name: 'commodity2',
          type: 'string'
        },
        "country": {
          name: 'country',
          type: 'string'
        },
        "countryFinalDest": {
          name: 'countryFinalDest',
          type: 'string'
        },
        "countryInvoiced": {
          name: 'countryInvoiced',
          type: 'string'
        },
        "countryInvoiced2": {
          name: 'countryInvoiced2',
          type: 'string'
        },
        "country2": {
          name: 'country2',
          type: 'string'
        },
        "currency": {
          name: 'currency',
          type: 'string'
        },
        "customer": {
          name: 'customer',
          type: 'string'
        },
        "customer2": {
          name: 'customer2',
          type: 'string'
        },
        "distributionChannel": {
          name: 'distributionChannel',
          type: 'string'
        },
        "distrChannel": {
          name: 'distrChannel',
          type: 'string'
        },
        "division": {
          name: 'division',
          type: 'string'
        },
        "division2": {
          name: 'division2',
          type: 'string'
        },
        "ericssonContractNumber": {
          name: 'ericssonContractNumber',
          type: 'string'
        },
        "globalCustomer": {
          name: 'globalCustomer',
          type: 'string'
        },
        "globalCustomer2": {
          name: 'globalCustomer2',
          type: 'string'
        },
        "industry": {
          name: 'industry',
          type: 'string'
        },
        "industry2": {
          name: 'industry2',
          type: 'string'
        },
        "pCode": {
          name: 'pCode',
          type: 'string'
        },
        "pCode2": {
          name: 'pCode2',
          type: 'string'
        },
        "periodYear": {
          name: 'periodYear',
          type: 'string'
        },
        "periodYear2": {
          name: 'periodYear2',
          type: 'string'
        },
        "planActIndicator": {
          name: 'planActIndicator',
          type: 'string'
        },
        "planActIndicator2": {
          name: 'planActIndicator2',
          type: 'string'
        },
        "plant": {
          name: 'plant',
          type: 'string'
        },
        "plant2": {
          name: 'plant2',
          type: 'string'
        },
        "product": {
          name: 'product',
          type: 'string'
        },
        "product2": {
          name: 'product2',
          type: 'string'
        },
        "profitCenter": {
          name: 'profitCenter',
          type: 'string'
        },
        "profitCenter2": {
          name: 'profitCenter2',
          type: 'string'
        },
        "recordType": {
          name: 'recordType',
          type: 'string'
        },
        "recordType2": {
          name: 'recordType2',
          type: 'string'
        },
        "region": {
          name: 'region',
          type: 'string'
        },
        "regionState": {
          name: 'regionState',
          type: 'string'
        },
        "salesOrder": {
          name: 'salesOrder',
          type: 'string'
        },
        "salesOrderHistory": {
          name: 'salesOrderHistory',
          type: 'string'
        },
        "salesOrdHist": {
          name: 'salesOrdHist',
          type: 'string'
        },
        "salesOrderItem": {
          name: 'salesOrderItem',
          type: 'string'
        },
        "salesOrdItem": {
          name: 'salesOrdItem',
          type: 'string'
        },
        "salesOrder2": {
          name: 'salesOrder2',
          type: 'string'
        },
        "salesOrganization": {
          name: 'salesOrganization',
          type: 'string'
        },
        "salesOrg": {
          name: 'salesOrg',
          type: 'string'
        },
        "shipToParty": {
          name: 'shipToParty',
          type: 'string'
        },
        "shipToParty2": {
          name: 'shipToParty2',
          type: 'string'
        },
        "soGroup": {
          name: 'soGroup',
          type: 'string'
        },
        "soGroup2": {
          name: 'soGroup2',
          type: 'string'
        },
        "soOffice": {
          name: 'soOffice',
          type: 'string'
        },
        "soOffice2": {
          name: 'soOffice2',
          type: 'string'
        },
        "soldToParty": {
          name: 'soldToParty',
          type: 'string'
        },
        "soldToParty2": {
          name: 'soldToParty2',
          type: 'string'
        },
        "solutionCode": {
          name: 'solutionCode',
          type: 'string'
        },
        "solutionCode2": {
          name: 'solutionCode2',
          type: 'string'
        },
        "wbsElement": {
          name: 'wbsElement',
          type: 'string'
        },
        "wbsElement2": {
          name: 'wbsElement2',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/KE30.js